import { render, staticRenderFns } from "./AppTerms.vue?vue&type=template&id=3638d2bb&scoped=true"
import script from "./AppTerms.vue?vue&type=script&lang=js"
export * from "./AppTerms.vue?vue&type=script&lang=js"
import style0 from "./AppTerms.vue?vue&type=style&index=0&id=3638d2bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638d2bb",
  null
  
)

export default component.exports